import { field } from "../../helpers";
import { companyTheme } from "../themes";
import {
  getCompanyAliasPreview,
  getCompanyCoverageSummary,
} from "../../utils/companyDetail";

const companyConfig = {
  label: "Companies",
  theme: companyTheme,
  summary: {
    primary: field("Company", ["ai_name", "company_summary.company_name"]),
    secondary: field("Alias", ["aliases", "company_summary.aliases"], {
      formatValue: (aliases) => getCompanyAliasPreview(aliases),
    }),
    columns: [
      field("Related docs", ["source_count"], {
        className: "flex-[0.8] min-w-[6rem]",
        kind: "accent",
      }),
      field("Aliases", ["aliases"], {
        className: "hidden md:block flex-[1] min-w-[8rem]",
        formatValue: (aliases) => `${Array.isArray(aliases) ? aliases.length : 0}`,
      }),
      field("Datasets", ["company_summary.datasets", "sources"], {
        className: "hidden lg:block flex-[1.65] min-w-[11rem]",
        formatValue: (_value, record) => getCompanyCoverageSummary(record),
      }),
    ],
  },
  detail: {
    meta: [],
    sections: [],
    links: [],
  },
};

export default companyConfig;
